import axios from "axios";
import { getToken } from "firebase/messaging";
import { messaging } from "../firebase-config";

export const useNotifications = () => {
  const subscribeToNotifications = async () => {
    try {
      //  await deleteToken(messaging); // Uncomment when testing locally
      const fcmToken = await getToken(messaging, {
        vapidKey:
          "BICYiBLmk13d9PQ0HYd7PM0x59IpfPASLdBngyYuf69TntoGq-bx6ev-dOOzFoojv_V4-hEWFI0rmpELqwH9sjs",
      });

      if (fcmToken) {
        await axios.put(
          `${process.env.REACT_APP_URL}/notifications/subscribe`,
          { token: fcmToken },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "X-Client-Type": "web",
            },
          }
        );
        localStorage.setItem("fcmToken", fcmToken);
      }
    } catch (err) {
    }
  };

  return { subscribeToNotifications };
};
